/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 24);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

/**
 * Events:
 * -- searchComplete: Emitted when a search query has returned from the server
 */
function Search() {
    this.searchData = jQuery("#quick-search-form").serializeArray();
    this.quiet = false;
}

// Prevent search results from opening units in new tab on mobile
function targetBlank() {
    if(jQuery.browser.mobile) {
        $('#rentals-container a[target="_blank"], #map-section a[target="_blank"]').removeAttr('target');
    }
}

//Global name of the completion event
Search.evtSearchComplete = "searchComplete";

//Global currently executing search (used to cancel previous searches if a new one is triggered)
Search.currentRequest = null;

Search.prototype.execute = function(callback) {
    var self = this;

    //Make the loading spinner visible
    if (!this.quiet) {
        startLoader('#section-rentals');
    }

    //Cancel any previously running search query (https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-readystate)
    if(Search.currentRequest !== null && Search.currentRequest.readyState < 4) {
        Search.currentRequest.abort();
    }

    Search.currentRequest = jQuery.getJSON('/searchCall', this.searchData, callback)
        .done(function(res) {
            //Trigger the "searchComplete" event
            jQuery("#quick-search-form").trigger(Search.evtSearchComplete, [ res.data, self ]);
        })
        .always(function() {
            //Hide the loading spinner
            if (!self.quiet) {
                pauseLoader('#section-rentals');
            }
            // Remove from new results
            targetBlank();
        })
        .fail(function(evt) {
            //If the event wasn't intentionally aborted, assume an error has occurred and alert the user
            if(evt.statusText !== "abort") {
                alert("I'm sorry, an error occurred during your search. Please try again.");
            }
        });
};

Search.prototype.getParam = function(name) {
    for(var i = 0; i < this.searchData.length; i++) {
        if(this.searchData[i].name == name) {
            return this.searchData[i].value;
        }
    }
    return null;
};

Search.prototype.setParam = function(name, value) {
    for(var i = 0; i < this.searchData.length; i++) {
        if(this.searchData[i].name == name) {
            this.searchData[i].value = value;
            return;
        }
    }

    this.searchData.push({
        'name': name,
        'value': value
    });
};

window.Search = Search;
window.targetBlank = targetBlank;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

/**
 * Represents the Calendar widget of the Search Results page
 * @param {string} id The DOM identifier for the calendar div, including its "#" character
 */
function SearchCalendar(id) {
    this.elem = document.getElementById(id);
    this.startDate = null;
    this.visible = 13;
    this.today = this.formatDateRead(new Date());

    //Attach an event handler for when search requests finish
    jQuery(document).on(Search.evtSearchComplete, this.searchComplete.bind(this));

    //Attach an event handler for when the display type changes
    jQuery(document).on("searchFormChangeDisplay", this.searchFormChangeDisplay.bind(this));

    jQuery(this.elem).on("click", ".va-grid-next", this.gridNext.bind(this));
    jQuery(this.elem).on("click", ".va-grid-prev", this.gridPrev.bind(this));

    this.initialize();
}


/**
 * Date format validator
 * @param  {Date} s date in M(M)/D(D)/(YY)YY format
 * @return {boolean} True if date is valid
 */
function isValidDate(s) {
    var dateFormat = /^\d{1,2}[\.|\/|-]\d{1,4}[\.|\/|-]\d{1,4}$/;

    if (dateFormat.test(s)) {
        // remove any leading zeros from date values
        s = s.replace(/0*(\d*)/gi,"$1");
        var dateArray = s.split(/[\.|\/|-]/);

        // correct month value
        dateArray[0] = dateArray[0] - 1;

        // correct year value
        if (dateArray[2].length < 4) {
            // correct year value
            dateArray[2] = (parseInt(dateArray[2]) < 50) ? 2000 + parseInt(dateArray[2]) : 1900 + parseInt(dateArray[2]);
        }

        var testDate = new Date(dateArray[2], dateArray[0], dateArray[1]);

        if (testDate.getDate() != dateArray[1] || testDate.getMonth() != dateArray[0] || testDate.getFullYear() != dateArray[2]) {
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
}

/**
 * Triggered when the calendar is advancing forward to the next date
 */
SearchCalendar.prototype.gridNext = function() {
    this.setVisible();
    var new_date = this.dateAdd(this.startDate,this.visible);
    this.setGridStart(new_date, true);
};

/**
 * Triggered when the calendar is advancing backward to the previous date
 */
SearchCalendar.prototype.gridPrev = function() {
    this.setVisible();
    var new_date = this.dateAdd(this.startDate, -this.visible);
    this.setGridStart(new_date, true);
};

/**
 * Assigns the visible attribute for some of the grid rows with the number of visible days
 * @todo Document this better?
 */
SearchCalendar.prototype.setVisible = function() {
    for(i=13; i>0; i--){
        if(jQuery("#rentals-container th.grid-col" + i).is(":visible")){
            this.visible = i;
            break;
        }
    }
};

/**
 * Adds a certain amount of days to a date
 * @param  {string} date   The date to change
 * @param  {integer} offset The number of days to change it by
 * @return {string}        The new date
 */
SearchCalendar.prototype.dateAdd = function(date, offset) {
    var parts = date.match(/(\d+)/g);
    var i = new Date(parts[2], parts[0]-1, parts[1]); // months are 0-based
    i.setDate(i.getDate() + offset);
    return this.formatDateRead(i);
};

/**
 * Determines the difference between two given dates
 * @param  {Date} date1    The date to compare
 * @param  {Date} date2    The date to compare it to
 * @return {integer}       The number of days between the two dates
 */
SearchCalendar.prototype.dateDiff = function(date1, date2) {
    //Get 1 day in milliseconds
    var one_day=1000*60*60*24;

    // Convert both dates to milliseconds
    var date1_ms = date1.getTime();
    var date2_ms = date2.getTime();

    // Calculate the difference in milliseconds
    var difference_ms = date2_ms - date1_ms;

    // Convert back to days and return
    return Math.round(difference_ms/one_day);
};

/**
 * Formats the given date in a standard way
 * @param  {Date} d A given date object
 * @return {string}   The formatted date string
 * @todo This will need to be internationalized (i18n)
 */
SearchCalendar.prototype.formatDateRead = function(d) {
    return ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear();
};

/**
 * Sets the first date that the grid should display
 * @param {string} date   The date to change to
 * @param {boolean} update If true, will trigger a search operation
 */
SearchCalendar.prototype.setGridStart = function(date, update) {
    this.startDate = date;
    window.search_form.change({gridS:date});

    if(update) {
        window.search_form.update();
    }
};

/**
 * Sets the Grid range, includes show 2 days before first day logic
 * @param  {Date} start  first day
 * @param  {Date} end    last day
 * @return {string}      date if grid start
 */
SearchCalendar.prototype.getGridStartFromRange = function(start, end) {
    var diff = this.dateDiff(start, end);
    var new_date = this.formatDateRead(start);

    if(diff + 3 < this.visible) {
        new_date = this.dateAdd(new_date, -2);
    } else if(diff + 1 < this.visible) {
        new_date = this.dateAdd(new_date, -1);
    }

    // Making sure that first day is not in the past and is a valid date
    if(new_date < this.today || !isValidDate(new_date)) {
        new_date = this.today;
    }

    return new_date;
};

/**
 * Gradually animates returning to the top of the page
 */
SearchCalendar.prototype.scrollToTop = function() {
    jQuery('body, html').animate({
        'scrollTop': 0
    }, 200);
};

/**
 * Initializes the controls and events for this widget
 */
SearchCalendar.prototype.initialize = function() {
    var self = this;

    if(this.startDate === null) {
        this.startDate = jQuery("#gridS").val();
    }

    jQuery("#gridDate").datepicker({
        minDate: 0
    }).change(function(e) {
        self.setGridStart(jQuery(this).val(), true);
    });

    if (!jQuery.browser.mobile) {
        jQuery("a.va-grid-date").fancybox({
            type:"ajax"
        }).tooltip({
            position: {
                my: "center bottom",
                at: "center top-5",
                using: function( position, feedback ) {
                  jQuery( this ).css( position );
                  jQuery( "<div>" )
                    .addClass( "tooltip-arrow" )
                    .addClass( feedback.vertical )
                    .addClass( feedback.horizontal )
                    .appendTo( this );
                }
            },
            hide: false
        });
    }
    else{
         jQuery("a.va-grid-date").fancybox({
            type:"ajax"
        });
    }
};

/**
 * Called by an event when the search form type changes
 * @param  {Object} evt  The event object
 * @param  {string} type The type of search form being switched to
 */
SearchCalendar.prototype.searchFormChangeDisplay = function(evt, type) {
    this.scrollToTop();
};

/**
 * Executes when a search finishes executing, updating the search form with the results
 * @param  {Object} res    The results returned from the server
 * @param  {Search} search The populated Search object that initiated the search
 */
SearchCalendar.prototype.searchComplete = function(evt, res, search) {
    this.scrollToTop();

    jQuery(this.elem).html(res.htmlCalendar);

    this.initialize();
};

window.SearchCalendar = SearchCalendar;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/**
 * Class for handling all interactions from the search bar
 *
 * This class emits 1 event:
 * -- searchFormDisplayChange: Triggered when the display type changes from map-tile to grid or other view types
 *
 * @param {string} id The DOM identifier for the form div, including its "#" character
 */
function SearchForm(id) {
    this.elem = document.getElementById(id);

    //Attach an event handler for when search requests finish
    jQuery(document).on(Search.evtSearchComplete, this.searchComplete.bind(this));

    //Attach an event handler for when the display type changes
    $(document).on("change", "#display", this.evtDisplayChange.bind(this));

    //Attach an event handler to AJAX search form submissions
    jQuery(this.elem).on("submit", this.evtSubmit.bind(this));

    //On pageload, assign the display type based on the session display data
    if (storageAvailable("localStorage")) {
        var display = window.sessionStorage.getItem("search-form-display");

        if(display) {
            $("#display").val(display).trigger("change");
        }
    }

    this.initialize();
}

/**
 * Local Storage checker
 */
function storageAvailable(type) {
    try {
        var storage = window[type],
            x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
    } catch (e) {
        return false;
    }
}

SearchForm.prototype.evtSubmit = function(evt, params) {
    evt.preventDefault();

    if(!params || params.ajax) {
        evt.preventDefault();

        var search = new Search();
        search.execute();
    } else {
        var loc = jQuery("#search-location");

        if(jQuery.trim(loc.val()) !== '' && loc.val() == loc.data('term')) {
            jQuery(evt.target).attr('action', loc.data('url'));
        } else {
            jQuery(evt.target).attr('action', '/WhereToGo');
        }
    }
};

SearchForm.prototype.update = function(changed_element) {
    if(changed_element == 'search') {
        jQuery("#CityID, #StateID, #DestID, #CountryID, #u, #c, #s, #d, #sw_lat, #sw_lng, #ne_lat, #ne_lng, #zoom, #center_lat, #center_lng").remove();
        removePlaceholders();
        jQuery(this.elem).find("[name=pageNumber]").val(1);
        jQuery(this.elem).trigger("submit", { ajax: false });
    } else {
        jQuery(this.elem).trigger("submit");
    }
};

SearchForm.prototype.change = function(filters) {
    var gridchange = false;
    var amenchange = false;
    for (var filter in filters) {

        if(filter=='gridS') gridchange = true;
        var value = filters[filter];

        if(jQuery(this.elem).find("[name='" + filter + "']").length > 0){
            var f = jQuery(this.elem).find('[name=\''+filter+'\']');

            if(f.attr('type')=='checkbox')
                f.prop('checked',value).change();
            else
                f.val(value);
                if(filter=='arrival' || filter=='departure' || filter=='display' || filter=='sw_lat')
                    f.change();

            var last_changed = filter;
        }
        else{
            jQuery(this.elem).append('<input type="hidden" name="' + filter + '" id="' + filter + '" value="' + value + '" />');
        }
    }
};

/**
 * Initializes datepickers for the date fields in the search bar (Exact/Flexible start date/end date)
 */
SearchForm.prototype.initializeSearchDates = function(start, end) {
    var self = this;

    jQuery(start).datepicker({
        changeMonth: false,
        changeYear: false,
        minDate: 0,
        onClose: function(val) {
            jQuery(this).blur();
        }
    }).change(function() {
        var val = jQuery.trim(jQuery(this).val());
        
        var i = new Date(val);
        var i2 = new Date(val);
        var o = jQuery(end).val();
        
        i2.setDate(i.getDate() + 1);

        if(o == jQuery(end).attr('placeholder')) {
            o = '';
        }

        var o2 = new Date(o);

        if(val === '' || val == jQuery(this).attr('placeholder')) {
            jQuery(end).val('').datepicker("option", "minDate", 0);
            self.update(jQuery(this).attr("name"));
        } else {
            jQuery(end).datepicker("option", "minDate", i2);

            if(o === '' || o2 < i2) {
                window.search_calendar.setGridStart(val,false);
                window.setTimeout(function() {
                    jQuery(end).datepicker("show");
                }, 150);
            } else {
                var new_date = window.search_calendar.getGridStartFromRange(i, o2);
                window.search_calendar.setGridStart(new_date, true);
            }
        }
    });
    
    jQuery(end).datepicker({
        changeMonth: false,
        changeYear: false,
        minDate: 0,
        onClose: function(val) {
            jQuery(this).blur();
        }
    }).change(function() {
        var o = jQuery.trim(jQuery(this).val());
        var i = jQuery(start).val();
        
        if(o == jQuery(this).attr('placeholder')) {
            o = '';
        }

        var o2 = new Date(o);
        
        if(i == jQuery(start).attr('placeholder')) {
            i = '';
        }

        var i2 = new Date(i);
        var new_date = window.search_calendar.getGridStartFromRange(i2,o2);
        window.search_calendar.setGridStart(new_date, false);
    });
};

SearchForm.prototype.initialize = function(is_search_page, map) {
    createLoader('#section-rentals');

    this.initializeSearchDates("#search-arrival","#search-departure");
    this.initializeSearchDates("#flexStart","#flexEnd");
};

SearchForm.prototype.evtDisplayChange = function(evt) {
    var searchResultsPage = $("#search-results-page");
    var searchViewToggle = $("#search-view-toggle");
    var mview = searchViewToggle.data('map');
    var cview = searchViewToggle.data('calendar');

    searchResultsPage.removeClass();

    if(evt.target.value === "calendar") {
        searchResultsPage.addClass("calendar");
        searchViewToggle.text(mview);
    } else if(evt.target.value === "list") {
        searchResultsPage.addClass("list");
        searchViewToggle.text(cview);
    } else if(evt.target.value === "map") {
        searchResultsPage.addClass("map");
        searchViewToggle.text(cview);
    }

    //Update the local storage so that this will be stored between pages
    if (storageAvailable("localStorage")) {
        window.sessionStorage.setItem("search-form-display", evt.target.value);
    }

    //Send out the display changed event for all listeners to handle
    jQuery("#search-results-page").trigger("searchFormChangeDisplay", [ evt.target.value ]);
};

/**
 * Executes when a search finishes executing, updating the search form with the results
 * @param  {Object} res    The results returned from the server
 * @param  {Search} search The populated Search object that initiated the search
 */
SearchForm.prototype.searchComplete = function(evt, res, search) {
    //Serialize the parameters to a URL encoded query string
    var paramsURL = jQuery.param(search.searchData);

    if(history.pushState) {
        window.history.pushState({'data' : paramsURL}, document.title, "?submit=Search&" + paramsURL);
    } else {
        window.location.hash = "submit=Search&" + paramsURL;
    }

    //Update the "1-30 of 90 rentals" text
    jQuery(".resultsFrom").text(res.offset + 1);
    jQuery(".resultsTo").text(res.offset + res.count);
    jQuery(".resultsOf, .mapResultsOf").text(res.total);
    jQuery(".mapResultsTo").text(res.count);

    //Hide or display the X-X of X rentals count if there are no results
    jQuery("#section-rentals .section-count").toggle(res.total !== "0");
    
    //Hides and shows number of results notice and statuses 
    if(res.total === "0") {
        jQuery(".map-loader-no-results-notice").addClass('visible');
        jQuery("#map-loader-results").hide();
        jQuery("#map-loader-no-results").show();
    } else {
        jQuery(".map-loader-no-results-notice").removeClass('visible');
        jQuery("#map-loader-no-results").hide();
        jQuery("#map-loader-results").show();
    }
};
window.SearchForm = SearchForm;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

/**
 * The tile-based widget for displaying results on the Search Results pages
 */
function SearchList() {
    //Attach an event handler for when search requests finish
    jQuery(document).on(Search.evtSearchComplete, this.searchComplete.bind(this));

    //Attach an event handler for when the display type changes
    jQuery(document).on("searchFormChangeDisplay", this.searchFormChangeDisplay.bind(this));

    //Attach an event handler for when a mouse hovers over one of the search results
    jQuery(document).on("mouseenter", "#rentals-container .listing", this.evtListingHovered);
}

/**
 * Event triggered when a mouse hovers over one of the listings
 * @param  {Object} evt A mouseenter/mouseover event
 */
SearchList.prototype.evtListingHovered = function(evt) {
    $(this).trigger("unitTileHovered", [ this ]);
};

/**
 * Gradually animates a pan to the top of the search results
 */
SearchList.prototype.scrollToTop = function() {
    jQuery('#search-page-main').animate({
        'scrollTop': 0
    }, 200);
};

/**
 * Called by an event when the search form type changes
 * @param  {Object} evt  The event object
 * @param  {string} type The type of search form being switched to
 */
SearchList.prototype.searchFormChangeDisplay = function(evt, type) {
    this.scrollToTop();
};

/**
 * Executes when a search finishes executing, updating the search form with the results
 * @param  {Object} evt    The event object
 * @param  {Object} res    The results returned from the server
 * @param  {Search} search The populated Search object that initiated the search
 */
SearchList.prototype.searchComplete = function(evt, res, search) {
    this.scrollToTop();

    jQuery("#rentals-container #mod-list").html(res.htmlList);
};

window.SearchList = SearchList;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/**
 * Represents the map widget of the Search Results page
 *
 * This object manages the event handling and rendering of the map. It also maintains:
 * * The link between listings and their markers
 * * The position and visibility of the InfoBox popup
 * @param {string} id The DOM identifier for the map element, including its "#" character
 */
function SearchMap(id) {
    this.id = id;
    this.elem = document.getElementById(id);
    this.map = null;
    this.markers = [];
    this.bounds = new google.maps.LatLngBounds();

    // InfoBox options
    this.infoWindow = new SearchMapInfoBox();
    this.infoWindowMulti = new SearchMapInfoBoxMulti();

    this.mapOptions = {
        maxZoom : 20,
        minZoom : 4,
        zoom: $(this.elem).data('zoom') || 8,
        scrollwheel: false,
        panControl: false,
        zoomControl: true,
        mapTypeControl: false,
        zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        scaleControl: false,
        streetViewControl: false,
        overviewMapControl: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: [
            {
                "featureType": "all",
                "elementType": "all",
                "stylers": [{"visibility": "off"}]
            },{
                "featureType": "administrative",
                "elementType": "all",
                "stylers": [{"visibility": "on"}]
            },{
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [{"visibility": "on"}]
            },{
                "featureType": "poi",
                "elementType": "all",
                "stylers": [{"visibility": "on"}]
            },{
                "featureType": "road",
                "elementType": "all",
                "stylers": [{"visibility": "on"}]
            },{
                "featureType": "transit",
                "elementType": "all",
                "stylers": [{"visibility": "on"}]
            },{
                "featureType": "water",
                "elementType": "all",
                "stylers": [{"visibility": "on"}]
            }
        ]
    };

    //Default to the location's lat/lng if provided
    if($(this.elem).data('lat')) {
        this.mapOptions.center = { lat: $(this.elem).data('lat'), lng: $(this.elem).data('lng') };
    }

    // Trigger a refresh when the Redo Search in Map button is clicked.
    jQuery(document).on("triggerMapRefresh", this.triggerRefresh.bind(this));

    // Fitting all the markers when changing displays.
    jQuery(document).on("triggerMarkerBounds", this.fitMarkers.bind(this));

    // Handle the "less/more map" button being clicked, and when display types change
    jQuery(document).on("searchFormResizeEnd searchFormChangeDisplay", "#search-results-page", this.render.bind(this));

    // Rerender infobox on close
    jQuery(document).on('reRenderInfoBox', "#map-section", this.render.bind(this));

    // Handle the "less/more map" button being clicked, and when display types change
    jQuery(document).on("unitTileHovered", this.evtUnitTileHovered.bind(this));

    // Attach an event handler for when search requests finish
    jQuery(document).on(Search.evtSearchComplete, this.searchComplete.bind(this));

    this.initialize();
}

/**
 * Adds event listeners for when various actions occur on the map
 *
 * This mostly deals with rerendering the map and updating buttons/statuses
 */
SearchMap.prototype.addListeners = function() {
    var self = this;

    // Refresh results when dragging the map arround
    google.maps.event.addListener(this.map, 'dragend', function() {
        google.maps.event.addListenerOnce(self.map, 'idle', function() {
            self.mapMoved();
        });
    });
    // Refresh results when Map zoom changes (might cause issues when changing/resizing map area?)
    google.maps.event.addListenerOnce(this.map, 'tilesloaded', function() {
        google.maps.event.addListener(self.map, 'zoom_changed', function() {
            // Idling here for when zoom is clicked in quick succession triggering a refresh
            // after each click instead of at the end of their final requested zoom level
            google.maps.event.addListenerOnce(self.map, 'idle', function() {
                self.mapMoved();
            });
        });
    });

    google.maps.event.addListener(this.infoWindow, 'domready', function(){
        self.infoWindowMulti.close();
    });
    google.maps.event.addListener(this.infoWindowMulti, 'domready', function(){
        self.infoWindow.close();
    });
};

/**
 * Triggers when the map has been panned, zoomed, or otherwise changed
 * in a way that may trigger a new search
 **/
SearchMap.prototype.mapMoved = function() {
    if(jQuery("#redoSearchWhenMoved :checked").length === 1){
        setTimeout(function() {
            jQuery("#redoSearchWhenMoved").trigger("triggerMapRefresh");
        }, 300);
    } else {
        jQuery("#redoSearchWhenMoved").hide();
        jQuery("#triggerRefreshButton").show();
    }
};

/**
 * Adds a single marker object to the map
 * @param {Object} listing A single search result
 */
SearchMap.prototype.addMarker = function(listing) {
    var self = this;
    
    // Normalize
    if(listing.Lat) listing.lat = listing.Lat;
    if(listing.Lng) listing.lng = listing.Lng;
    
    if((listing.lat && listing.lat != '0.000000') && (listing.lng && listing.lng != '0.000000')) {
        // Recreate the marker as a Google Maps marker
        marker = new SearchMapMarker(this.map, listing);
        marker.infoWindow = this.infoWindow;

        // Pushing marker with all the goodies
        this.markers.push(marker);
    }
};

/**
 * Adds a multi marker object to the map
 * @param {Array} listings An array of search results
 */
SearchMap.prototype.addMarkerMulti = function(listings) {
    if((listings[0].lat && listings[0].lat != '0.000000') && (listings[0].lng && listings[0].lng != '0.000000')) {
        // Recreate the marker as a Google Maps marker
        marker = new SearchMapMarkerMulti(this.map, listings);
        marker.infoWindow = this.infoWindowMulti;

        // Pushing marker with all the goodies
        this.markers.push(marker);
    }
};

/**
 * Adds multiple marker objects to the map
 * @param {Object[]} listings An array of search results
 */
SearchMap.prototype.addMarkers = function(listings) {
    multiListings = [];
    var singleListings = [];
    //For every listing
    for(var x = 0; x < listings.length; x++) {
        var listing = listings[x];
        //Compare with every listing
        for(var y = 0; y < listings.length; y++) {
            var compare = listings[y];
            //Compare the outer listing with the inner listing on their geo coords
            if(listing.unitID != compare.unitID && listing.lat == compare.lat && listing.lng == compare.lng) {
                //If the coords match, and listing hasn't been added to a group, add the listing to multi listings
                if(!multiListings[listing.lat]){
                    multiListings[listing.lat] = [];
                }
                if(!multiListings[listing.lat][listing.lng]){
                    multiListings[listing.lat][listing.lng] = [];
                }
                if(!listings[x].added){
                    multiListings[listing.lat][listing.lng].push(listing);
                    listings[x].added = true;
                }
                if(!listings[y].added){
                    multiListings[listing.lat][listing.lng].push(compare);
                    listings[y].added = true;
                }
            }
        }

        if(!listings[x].added) {
            singleListings.push(listing);
        }
    }

    //Add the single listings as single markers
    for(var i = 0; i < singleListings.length; i++) {
       this.addMarker(singleListings[i]);
    }

    //Add the multiple listings as multi markers
    var keys = objKeys(multiListings);
    for(var i = 0; i < keys.length; i++) {
        var group = multiListings[keys[i]];
        var gKeys = objKeys(group);
        for (var j = 0; j < gKeys.length; j++) {
            var listings = group[gKeys[j]];
            this.addMarkerMulti(listings);
        }
    }
}

function objKeys(obj) {
  var keys = [];
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) keys.push(key);
  }
  return keys;
}

/**
 * Event triggered when a tile is hovered over by the mouse in the search results list
 * @param  {Object} evt     An event emitted by the SearchList object
 * @param  {Object} listing A search result object
 */
SearchMap.prototype.evtUnitTileHovered = function(evt, listing) {
    var unitID = $(listing).data('unitid');

    // check through all markers
    for(var i = 0; i < this.markers.length; i++) {
        if(this.markers[i].markerType === 'single') {
            if(this.markers[i].listing.unitID == unitID) {
                this.markers[i].bounce();
            }
        } else {
            // check through all listings on multi marker
            for(var j = 0; j < this.markers[i].listings.length; j++) {
                if(this.markers[i].listings[j].unitID == unitID) {
                    this.markers[i].bounce();
                }
            }
        }
    }
};

/**
 * Fits the bounds of the map to the markers present on it
 *
 * NOTE: This method will trigger a "zoom" action on the map, simulating a user
 * zooming in/out of that geographic area.
 * @param  {SearchMapMarker[]} markers An array of marker objects
 */
SearchMap.prototype.fitMarkers = function(markers) {
    var bounds = new google.maps.LatLngBounds();

    for(var i = 0; i < this.markers.length; i++) {
        bounds.extend(this.markers[i].getPosition());
    }

    this.map.fitBounds(bounds);
};

/**
 * Initializes the map. Should be called on page-load for the map to work
 */
SearchMap.prototype.initialize = function() {
    var listingsData = $("#listings-data");

    if(listingsData.length === 0) {
        return;
    }

    //Default to the location coordinates if no search results were found
    if(!this.mapOptions.center && listingsData.data('listings').length === 0 && $(this.elem).data('location-lat')) {
        this.mapOptions.center = { lat: $(this.elem).data('location-lat'), lng: $(this.elem).data('location-lng') };
    }

    this.map = new google.maps.Map(document.getElementById(this.id), this.mapOptions);

    if(listingsData.data('listings').length > 0) {
        // Add the markers from the JSON
        this.addMarkers(listingsData.data('listings'));

        // Zoom in only if the lat/lng haven't been provided
        if(!this.mapOptions.center) {
            this.fitMarkers();
        }
    }

    this.addListeners();

};

/**
 * Shows any markers currently in the array.
 */
SearchMap.prototype.showMarkers = function() {
    this.setAllMap(this.map);
};

/**
 * Re-renders the existing map
 * This is excellent for when a window is being resized, or a map is being shown after having been
 * hidden for a while.
 */
SearchMap.prototype.render = function() {
    if(this.map) {
        google.maps.event.trigger(this.map,'resize');
    } else {
        this.initialize();
    }
};

/**
 * Sets the map on all markers in the array.
 */
SearchMap.prototype.setAllMap = function(map) {
    for (var i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(map);
    }
};

/**
 * Triggers a new search event from the map widget
 *
 * This is generally called due to a user action such as panning or zooming
 */
SearchMap.prototype.triggerRefresh = function() {

    jQuery("#map-loader-searching").show();
    jQuery("#map-loader-no-results").hide();
    jQuery("#map-loader-results").hide();

    if(jQuery("#redoSearchWhenMoved :checked").length === 0){
        jQuery("#redoSearchWhenMoved").show();
        jQuery("#triggerRefreshButton").hide();
    }

    if(typeof this.map == 'undefined' || this.map === null) return;

    var center = this.map.getCenter();
    var bounds = this.map.getBounds();
    var changes = {};

    changes.ne_lat = bounds.getNorthEast().lat();
    changes.ne_lng = bounds.getNorthEast().lng();
    changes.sw_lat = bounds.getSouthWest().lat();
    changes.sw_lng = bounds.getSouthWest().lng();
    changes.zoom = this.map.getZoom();
    changes.center_lat = center.lat();
    changes.center_lng = center.lng();

    search_form.change(changes);

    // Reset the page number to 1 when the map location/zoom changes
    $("#pageNumber").val("1");

    var search = new Search();

    search.execute();
};

/**
 * Executes when a search finishes executing, updating the search form with the results
 * @param  {Object} res    The results returned from the server
 * @param  {Search} search The populated Search object that initiated the search
 */
SearchMap.prototype.searchComplete = function(evt, res, search) {

    // Clear all markers from the map
    this.setAllMap(null);
    this.markers = [];

    // Add the new markers
    this.addMarkers(res.listings);
    jQuery("#map-loader-searching").hide();
    renderCarousel();
};


/**
 * Loader for html-initialized maps (vs embedded <script> tags)
 */
jQuery(new_map.initializeFromHTML);

window.SearchMap = SearchMap;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/**
 * The popup box used by the Search Results map widget
 *
 * This directly extends from the InfoBox library in the CDN
 * @param {Object} options Any custom options to add to the info box
 */
function SearchMapInfoBox(options) {
    InfoBox.call(this, $.extend({
        disableAutoPan: false,
        maxWidth: 0,
        pixelOffset: new google.maps.Size(-130, -313),
        zIndex: null,
        boxClass: "info-box",
        closeBoxMargin: "6px",
        closeBoxURL: "/images/close.gif",
        infoBoxClearance: new google.maps.Size(5, 46),
        isHidden: false,
        pane: "floatPane",
        enableEventPropagation: false
    }, options));
}

if(typeof InfoBox === undefined) {
    console.error("InfoBox library was not found");
}

//Extend the Google Maps marker
SearchMapInfoBox.prototype = Object.create(InfoBox.prototype);
SearchMapInfoBox.prototype.constructor = InfoBox;

window.SearchMapInfoBox = SearchMapInfoBox;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/**
 * The popup box used by the Search Results map widget
 *
 * This directly extends from the InfoBox library in the CDN
 * @param {Object} options Any custom options to add to the info box
 */
function SearchMapInfoBoxMulti(options) {
    InfoBox.call(this, $.extend({
        disableAutoPan: false,
        maxWidth: 0,
        pixelOffset: new google.maps.Size(-129, -33),
        zIndex: null,
        boxClass: "info-box multi-pin",
        closeBoxMargin: "6px",
        closeBoxURL: "/images/close.gif",
        infoBoxClearance: new google.maps.Size(5, 46),
        isHidden: false,
        pane: "floatPane",
        alignBottom: true,
        enableEventPropagation: false
    }, options));
}

if(typeof InfoBox === undefined) {
    console.error("InfoBox library was not found");
}
//Extend the Google Maps marker
SearchMapInfoBoxMulti.prototype = Object.create(InfoBox.prototype);
SearchMapInfoBoxMulti.prototype.constructor = InfoBox;
SearchMapInfoBoxMulti.prototype.renderListings = function(listings, length) {
    var sliderCount = 1;
    var transition = false;
    if(listings.length > 0) {
        var slider = '<div class="flexslider flexslider-units"><div class="rental-count">&nbsp; &nbsp; <span id="slider-count">' + sliderCount + '</span> of ' + listings.length + ' Rentals Here</div><ul class="slides">';

        for (var i = 0, l = listings.length; i < l; i++) {
            var content = $(".listing[data-unitid=" + listings[i].unitID + "] .mod-listing").data('initSlide');
            slider += "<li class='slide-counter'>" + content + "</li>";
        }

        slider += '</ul></div><div class="custom-navigation"><a href="#" class="flex-prev"></a><div class="custom-controls-container"></div><a href="#" class="flex-next"></a></div>';
        this.close();
        this.open(this.map, this);
        this.setContent(slider);
        // multi unit flexslider carousel
        google.maps.event.addListenerOnce(this,'domready',function(){
            var unitFlexslider =  $('.flexslider-units .slides');
            unitFlexslider.flexslider({
                selector: ".slide-counter",
                controlNav: false,
                slideshow: false,
                animationSpeed: 200,
                touch: false,
                keyboard: false,
                controlsContainer: $(".custom-controls-container"),
                customDirectionNav: $(".custom-navigation a"),

                before: function(unitFlexslider) {
                    var index = unitFlexslider.animatingTo + 1;
                    $('#slider-count').html(unitFlexslider.animatingTo+1);
                },
                start: function(){
                    unitFlexslider.resize();
                    unitFlexslider.find(".flexslider-listing").removeClass("flexslider-listing").addClass("flexslider-multi");

                    $(".flexslider-multi .slides").children('li').addClass('slide');

                    $('.flexslider-multi').flexslider({
                        selector: ".slides > .slide",
                        controlNav: false,
                        slideshow: false,
                        animationSpeed: 200,

                        // lazy load carousel images
                        start: function(slider){ // Fires when the slider loads the first slide
                            var slide_count = slider.count - 2;

                            $(slider).find('img.lazy:eq(0), img.lazy:eq(' + slide_count + ')').each(function() {
                                var src = $(this).attr('data-src');
                                $(this).attr('src', src).removeAttr('data-src');
                            });
                        },
                        before: function(slider) { // Fires asynchronously with each slider animation
                            var slides     = slider.slides,
                                next       = slider.animatingTo,
                                $slide     = $(slides[next]),
                                $img       = $slide.find('img[data-src]'),
                                nxt_slide  = next,
                                prev_slide = next - 2;

                            $slide.parent().find('img.lazy:eq(' + prev_slide + '), img.lazy:eq(' + nxt_slide + ')').each(function() {
                                    var src = $(this).attr('data-src');
                                    $(this).removeAttr('data-src').attr('src', src);
                                    $(this).parent().addClass('flex-slide');
                                });
                        }
                    });
                }
            });
        });
    }
};
window.SearchMapInfoBoxMulti = SearchMapInfoBoxMulti;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

/**
 * Represents a single map marker for the Search Results map widget
 *
 * This directly extends from the Google Maps Marker object
 * @param {SearchMap} map     The map to attach to
 * @param {Object} listing    A single search result
 */
function SearchMapMarker(map, listing) {
    this.map = map;
    this.listing = listing;
    this.markerType = 'single';

    this.locationInfo = new google.maps.InfoWindow({
          content: 'Actual location within .25 mile radius.'
    });

    this.fuzzyCircle = this.getFuzzyCirle(listing.lat, listing.lng);

    var markerOptions = {
        map: this.map,
        icon: this.getMarkerImage(),
        position: new google.maps.LatLng(listing.lat, listing.lng)
    };

    if(listing.Title !== null) {
        markerOptions.title = listing.title;
    }

    //Construct the parent
    google.maps.Marker.call(this, markerOptions);

    this.addListeners();
}

if(typeof google.maps.Marker === undefined) {
    console.error("Google Maps Marker library was not found");
}

//Extend the Google Maps marker
SearchMapMarker.prototype = Object.create(google.maps.Marker.prototype);
SearchMapMarker.prototype.constructor = google.maps.Marker;

/**
 * Adds event listeners for when the marker is clicked or hovered
 */
SearchMapMarker.prototype.addListeners = function() {
    // Open infobox when marker is clicked
    google.maps.event.addListener(this, 'click', this.evtMarkerClick.bind(this));

    google.maps.event.addListener(this, 'mouseover', this.evtMarkerHover.bind(this));
    google.maps.event.addListener(this, 'mouseout', this.evtMarkerHoverLeave.bind(this));
};

/**
 * Bounce the marker once and bring it to the foreground
 */
SearchMapMarker.prototype.bounce = function() {
    var listing = $(".listing[data-unitid=" + this.listing.unitID + "] .mod-listing").get(0);

    this.setAnimation(google.maps.Animation.BOUNCE);
    this.setIcon(this.getMarkerImage(true));
    // When user leaves hover state on listing, color goes from orange to white
    $(listing).mouseleave(function() {
        this.setIcon(this.getMarkerImage(false));
    }.bind(this));

    window.setTimeout(function () {
        this.setAnimation(null);
    }.bind(this), 700);

    this.setZIndex(google.maps.Marker.MAX_ZINDEX + 1000);

};

/**
 * When an event marker is clicked, open an InfoWindow displaying listing information
 */
SearchMapMarker.prototype.evtMarkerClick = function(evt) {
    var listing = $(".listing[data-unitid=" + this.listing.unitID + "] .mod-listing");

    if(listing[0]) {
        // Copy the listing's content
        preSlide = listing.data('initSlide');
        this.infoWindow.close();
        this.infoWindow.setContent(preSlide);
        this.infoWindow.open(this.map, this);

        var uid = this.listing.unitID;
        google.maps.event.addListener(this.infoWindow,'domready',function(){
            $('.info-box').find(".listing-img-container .flexslider").removeClass("flexslider-listing").addClass("flexslider-single");
            
            $('.flexslider-single').flexslider({
                controlNav: false,
                slideshow: false,
                animationSpeed: 200,
                keyboard: false,
                
                // lazy load carousel images
                start: function(slider) { // Fires when the slider loads the first slide
                  var slide_count = slider.count - 2;

                  $(slider).find('img.lazy:eq(0), img.lazy:eq(' + slide_count + ')').each(function() {
                      var src = $(this).attr('data-src');
                      $(this).attr('src', src).removeAttr('data-src');
                    });
                },
                before: function(slider) { // Fires asynchronously with each slider animation
                  var slides     = slider.slides,
                      next       = slider.animatingTo,
                      $slide     = $(slides[next]),
                      $img       = $slide.find('img[data-src]'),
                      nxt_slide  = next,
                      prev_slide = next - 2;

                  $slide.parent().find('img.lazy:eq(' + prev_slide + '), img.lazy:eq(' + nxt_slide + ')').each(function() {
                      var src = $(this).attr('data-src');
                      $(this).removeAttr('data-src').attr('src', src);
                      $(this).parent().addClass('flex-slide');
                    });
                }
            });
        });
    }
};

/**
 * Hover on Marker highlights corresponding listing
 */
SearchMapMarker.prototype.evtMarkerHover = function(evt) {
    // Update marker icon with image stack
    this.setIcon(this.getMarkerImage(true));

    if(this.listing.fuzzy) {
        this.fuzzyCircle.setVisible(true);
        this.locationInfo.open(this.map, this);
    }

};

/**
 * Resetting marker image and z-index
 */
SearchMapMarker.prototype.evtMarkerHoverLeave = function(evt) {
    var image = this.getMarkerImage();

    // Updating marker icon with image stack
    this.setIcon(image);

    // Lets remove the circle from the Addressless marker
    if(this.listing.fuzzy) {
        this.fuzzyCircle.setVisible(false);
        this.locationInfo.close();
    }

};

/**
 * Generates a Vacasa-branded marker image for displaying on the screen
 * @param  {boolean} hovered If the image should represent the hover state for the marker
 * @return {Object}          An object describing the image attributes
 */
SearchMapMarker.prototype.getMarkerImage = function(hovered) {
    var url = 'https://d33zkqzv7i9ae0.cloudfront.net/images/marker_pins_gray.png';
    var size = new google.maps.Size(28, 43);
    var anchor = new google.maps.Point(14, 40);
    var scaledSize;
    var origin;
    var customPin;

    // Setting Scaling
    if(window.devicePixelRatio <= 1) {
        // Non-Retina
        scaledSize = new google.maps.Size(280, 328);
    } else {
        // Retina
        scaledSize = new google.maps.Size(140, 164);
    }

    // Normal Marker
    if(window.devicePixelRatio <= 1){
        // Non-Retina
        // Brown
        origin = new google.maps.Point(0,164);
        customPin = new google.maps.Point(224,164); // Red
    } else {
        // Retina
        // Brown
        origin = new google.maps.Point(0,0);
        customPin = new google.maps.Point(112,41); // Red
    }

    // Inactive Marker
    if(!this.listing.active) {
        if(window.devicePixelRatio <= 1){
            // Non-Retina
            // Grey
            origin = new google.maps.Point(168,164);
        } else {
            // Retina
            // Grey
            origin = new google.maps.Point(84,0);
        }
    }

    if(hovered) {
        // Normal Selected Marker
        if(window.devicePixelRatio <= 1) {
            // Non-Retina
            // Brown Selected
            origin = new google.maps.Point(0,246);
        } else {
            // Retina
            // Brown Selected
            origin = new google.maps.Point(0,41);
        }

        // Inactive Selected Marker
        if(!this.listing.active){
            if(window.devicePixelRatio <= 1){
                // Non-Retina
                // Grey Selected
                origin = new google.maps.Point(168,246);
            } else {
                // Retina
                // Grey Selected
                origin = new google.maps.Point(84,41);
            }
        }
    }

    if(this.listing.fuzzy) {
        // Dots for homes that dont have an address
        // Changing image, size, and anchor points
        url = 'https://d33zkqzv7i9ae0.cloudfront.net/images/marker_dots_gray.png';
        anchor = new google.maps.Point(14, 14);
        size = new google.maps.Size(28, 29);
    }

    // All the things that make up the marker image
    var image = {
        url: url,
        size: size,
        scaledSize: scaledSize,
        origin: origin,
        anchor: anchor
    };

    return image;
};

/**
 * Generates a Vacasa-branded circle for markers with an approximate location
 * @param  {float} lat The latitute where the circle should appear
 * @param  {float} lng The longitude where the circle should appear
 * @return {google.maps.Circle}     An instantiated Circle object for rendering
 */
SearchMapMarker.prototype.getFuzzyCirle = function(lat, lng) {
    // // Lets add a circle to the Addressless marker
    circleOptions = {
        strokeColor: '#FCD700',
        strokeOpacity: 0.75,
        strokeWeight: 2,
        fillColor: '#FCD700',
        fillOpacity: 0.25,
        map: this.map,
        visible: false,
        center: new google.maps.LatLng(lat, lng),
        radius: 403 // in meters ~ .25 mile
    };

    return new google.maps.Circle(circleOptions);
};

window.SearchMapMarker = SearchMapMarker;


/***/ }),
/* 11 */
/***/ (function(module, exports) {

/**
 * Represents a single map marker for the Search Results map widget
 *
 * This directly extends from the Google Maps Marker object
 * @param {SearchMap} map     The map to attach to
 * @param {Array} listings    An array of multiple search results
 * @param {decimal} lat       Latitude of the marker
 * @param {decimal} lng       Longitude of the marker
 */
function SearchMapMarkerMulti(map, listings) {
    this.map = map;
    this.listings = listings;
    this.lat = listings[0].lat;
    this.lng = listings[0].lng;
    this.markerType = 'multi';
    this.show = false;
    this.label = listings.length.toString();

    var markerOptions = {
        position: new google.maps.LatLng(this.lat, this.lng),
        map: this.map,
        title: listings.length + " units",
        icon: this.getMarkerImage(false, this.label)
    };

    //Construct the parent
    google.maps.Marker.call(this, markerOptions);

    this.addListeners();
}

if(typeof google.maps.Marker === undefined) {
    console.error("Google Maps Marker library was not found");
}

//Extend the Google Maps marker
SearchMapMarkerMulti.prototype = Object.create(google.maps.Marker.prototype);
SearchMapMarkerMulti.prototype.constructor = google.maps.Marker;

/**
 * Adds event listeners for when the marker is clicked or hovered
 */
SearchMapMarkerMulti.prototype.addListeners = function() {
    // Open infobox when marker is clicked
    google.maps.event.addListener(this, 'click', this.evtMarkerClick.bind(this));
    google.maps.event.addListener(this, 'mouseover', this.evtMarkerHover.bind(this));
    google.maps.event.addListener(this, 'mouseout', this.evtMarkerHoverLeave.bind(this));
};

/**
 * Bounce the marker once and bring it to the foreground
 */
SearchMapMarkerMulti.prototype.bounce = function() {
    var listings = this.listings;
    var listingElement = '';

    listings.forEach(function(listing){
        listingElement = $(".listing[data-unitid=" + listing.unitID + "] .mod-listing");
        // When user leaves hover state on listing, color goes from orange to white
        $(listingElement).mouseleave(function() { 
            this.setIcon(this.getMarkerImage(false, this.label));
        }.bind(this));
        $(listingElement).hover(function() {
            this.setZIndex(google.maps.Marker.MAX_ZINDEX + 1000);
        }.bind(this));
    }.bind(this));

    this.setIcon(this.getMarkerImage(true, this.label));
    this.setAnimation(google.maps.Animation.BOUNCE);


    window.setTimeout(function () {
        this.setAnimation(null);
    }.bind(this), 700);

    this.setZIndex(google.maps.Marker.MAX_ZINDEX + 1000);
};

/**
 * When an event marker is clicked, open an InfoWindow displaying listing information
 */
SearchMapMarkerMulti.prototype.evtMarkerClick = function(evt) {
    this.infoWindow.renderListings(this.listings, this.listings.length);
    this.infoWindow.open(this.map, this);
};

/**
 * Hover on Marker highlights corresponding listing
 */
SearchMapMarkerMulti.prototype.evtMarkerHover = function(evt) {
    // Update marker icon with image stack
    this.setIcon(this.getMarkerImage(true,this.label));
};

/**
 * Resetting marker image and z-index
 */
SearchMapMarkerMulti.prototype.evtMarkerHoverLeave = function(evt) {
    var image = this.getMarkerImage(false, this.label);
    // Updating marker icon with image stack
    this.setIcon(image);
};

/**
 * Generates a Vacasa-branded marker image for displaying on the screen
 * @param  {boolean} hovered If the image should represent the hover state for the marker
 * @param  {string}  label   The number of multi units
 * @return {Object}          An object describing the image attributes
 */
SearchMapMarkerMulti.prototype.getMarkerImage = function(hovered, label) {

    var isIE = false;
    var size = new google.maps.Size(32, 32);
    var scaledSize = new google.maps.Size(32, 32);
    var anchor = new google.maps.Point(15, 33);
    var fillColor = 'white';
    var strokeColorInner = 'rgb(39, 26, 22)';
    var strokeColorOuter = 'rgb(100, 100, 100)';
    var url;
    var isAllBooked = allBooked(this.listings);

    // Test for inactive pins
    function allBooked(x) {
        for(var i = 0; i < x.length; i++) {
            if (x[i].active === false) {
                if(x[i].active !== x[0].active) {
                   // console.log("False - multipin is partially booked");
                    return false;
                }
                //console.log("True - multipin is all booked");
                return true;
            }
        }
    }

    // check if browser is IE
    if(jQuery.browser.msie || jQuery.browser.msedge) {
        isIE = true;
    }

    if (isIE) {
        // If inactive
        if (isAllBooked) {
            if (hovered) {
                url = '/images/ieMultiMarkerInactiveHovered_gray.png';
            }
            else {
                url = '/images/ieMultiMarkerInactive_gray.png';
            }
        }
        // If active
        else {
            if (hovered) {
                url = '/images/ieMultiMarkerHovered_gray.png';
            }
            else {
                url = '/images/ieMultiMarker_gray.png';
            }
        }
    }
    else {
        if (hovered)
            fillColor = 'rgb(240, 180, 33)';

        if (isAllBooked) {
            strokeColorInner = 'rgb(143,143,143)';
            strokeColorOuter = 'rgb(191,191,191)';
        }

        url = 'data:image/svg+xml;utf-8, \
        <svg height="32px" width="32px" id="multi-test" data-name="multi" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"> \
            <circle cx="16" cy="16" r="16" fill="' + strokeColorInner + '"/> \
            <circle cx="16" cy="16" r="15" fill="' + strokeColorOuter + '" /> \
            <circle cx="16" cy="16" r="10" fill="' + fillColor + '" stroke="white" stroke-width="1.2" /> \
            <text dx="50%" dy="21" fill="black" text-anchor="middle" font-size="14px" font-weight="normal" font-family="ssp, Source Sans Pro, Helvetica, Arial, sans-serif">' + label + '</text> \
        </svg>';
    }

    // All the things that make up the marker image
    var image = {
        url: url,
        size: size,
        scaledSize: scaledSize,
        anchor: anchor
    };
    return image;
};

window.SearchMapMarkerMulti = SearchMapMarkerMulti;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

/**
 * Initializes all of the widgets, spinning off onload events from each of them
 */
$(function() {
    var $ = jQuery;
    window.search_form = new SearchForm("quick-search-form");
    window.search_list = new SearchList();
    window.search_calendar = new SearchCalendar("calendar-section");
    window.search_map = new SearchMap("map_canvas_search");

    /* mobile nav */
    $("#search-view-calendar").on("click", function() {
        $("#display").val("calendar").trigger("change");
    });

    $("#search-view-list").on("click", function() {
        $("#display").val("list").trigger("change");
    });

    $("#search-view-map").on("click", function() {
        $("#display").val("map").trigger("change");
    });

    checkForEllipses();
    renderCarousel();
});

function renderCarousel() {
  // adding carousel to listings
  $('.mod-listing').each(function(){
      $(this).data('initSlide', $(this).html());
      $(this).find('.flexslider-listing').flexslider({
          controlNav: false,
          slideshow: false,
          animationSpeed: 200,
          keyboard: false,

            // lazy load carousel images
            start: function(slider) { // Fires when the slider loads the first slide
                var slide_count = slider.count - 2;

                $(slider).find('img.lazy:eq(0), img.lazy:eq(' + slide_count + ')').each(function() {
                    var src = $(this).attr('data-src');
                    $(this).attr('src', src).removeAttr('data-src');
                });
            },
            before: function(slider) { // Fires asynchronously with each slider animation
                var slides     = slider.slides,
                    next       = slider.animatingTo,
                    $slide     = $(slides[next]),
                    $img       = $slide.find('img[data-src]'),
                    nxt_slide  = next,
                    prev_slide = next - 2;

                $slide.parent().find('img.lazy:eq(' + prev_slide + '), img.lazy:eq(' + nxt_slide + ')').each(function() {
                    var src = $(this).attr('data-src');
                    $(this).removeAttr('data-src').attr('src', src);
                    $(this).parent().addClass('flex-slide');
                });
            }
        });
    });
}

/**
 * Toggle split and calendar view when the button is pressed
 */
$(function() {
    var once = true;

    // Desktops
    $("#search-view-toggle").on("click", function() {
        if($("#display").val() !== "calendar") {
            $("#display").val("calendar").trigger("change");
            $("#map-resizing").addClass("no-map");
            once = false;
        } else {
            $("#display").val("list").trigger("change");
            if(once){
                $("#display").val("list").trigger("triggerMarkerBounds");
                once = false;
            }

            // Fixes safari animating the listings when switching from the calendar
            noTrans();
        }
    });

    // Mobile triggering a marker bounds when clicking on the map
    $("#search-view-map").on("click", function() {
        if(once){
            $("#display").trigger("triggerMarkerBounds");
            once = false;
        }
    });
});

/**
 * Saves SearchWhenMoved checkbox state
 */
$(function() {
    var mapSearchWhenMoved;
    $("#redoSearchWhenMoved").on('click', function(){
        if (storageAvailable('localStorage')) {
            if($("#redoSearchWhenMoved :checked").length === 1){
                window.sessionStorage.setItem("mapSearchWhenMoved", 'true');
            } else {
                window.sessionStorage.setItem("mapSearchWhenMoved", 'false');
            }
        }
    });

    if (storageAvailable('localStorage')) {
        mapSearchWhenMoved = window.sessionStorage.getItem("mapSearchWhenMoved");
    }

    if(mapSearchWhenMoved === 'false'){
        $("#redoSearchWhenMoved input").removeAttr("checked");
    }
});

/**
 * Map more/less map button trigger
 */
$(function() {
    var mapWidth;
    if (storageAvailable('localStorage')) {
        mapWidth = window.sessionStorage.getItem("mapWidth");

        // Setting the more-map if we have it from previous session
        // Also setting no transition since this is a fresh page load
        if(mapWidth === 'more-map') {
            moreMap();
            noTrans();
        } else {
            lessMap();
        }
    }

    /**
     * The more/less-map toggler
     */
    $("#map-width-toggle").on('click', function() {
        if (storageAvailable('localStorage')) {
            mapWidth = window.sessionStorage.getItem("mapWidth");
        }

        if (mapWidth === 'more-map') {
            lessMap();
            mapWidth = 'less-map';
        } else {
            moreMap();
            mapWidth = 'more-map';
        }
    });
});

/**
 * Adding and removing animations
 */
function noTrans() {
    $("#map-section, #search-page-main").addClass("transition-none");
    setTimeout(function(){
        $("#map-section, #search-page-main").removeClass("transition-none");
    }, 500);
}

/**
 * Makes the map wider
 */
function moreMap() {
    if (storageAvailable('localStorage')) {
        window.sessionStorage.setItem("mapWidth", 'more-map');
    }
    $(".more-map-btn").hide();
    $(".less-map-btn").show();
    $("#map-resizing").removeClass("less-map no-map").addClass("more-map").trigger("searchFormResizeBegin");
    $("#map-resizing").one("transitionend", function() {
        $("#map-resizing").trigger("searchFormResizeEnd");
        checkForEllipses();
    });
}

/**
 * Makes the map less wide
 */
function lessMap() {
    if (storageAvailable('localStorage')) {
        window.sessionStorage.setItem("mapWidth", 'less-map');
    }
    $(".more-map-btn").show();
    $(".less-map-btn").hide();
    $("#map-resizing").removeClass("more-map no-map").addClass("less-map").trigger("searchFormResizeBegin");
    $("#map-resizing").one("transitionend", function() {
        $("#map-resizing").trigger("searchFormResizeEnd");
        checkForEllipses();
    });
}

/**
 * Local Storage checker
 */
function storageAvailable(type) {
    try {
        var storage = window[type],
            x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
    } catch (e) {
        return false;
    }
}

/**
 * Setting refresh Map results trigger
 */
$(function() {
    $("#triggerRefreshButton").on("click", function() {
        $("#triggerRefreshButton").trigger("triggerMapRefresh");
    });
});

/**
 * Check and add classes when window is resized
 */
$(function() {
    window.onresize = function(){
        $("#map-resizing").removeClass("less-map");
    };
});

/**
 * Related destinations show more
 */
$(function() {
    $(".related-dest-show-more").on("click", function() {
        $(".related-destinations-section ul").addClass("open");
        $(".related-dest-show-more").hide();
        $(".gray-fade-line").hide();
    });
});

/**
 * Only display "show more" if last item in destination list has ellipses
 */
function checkForEllipses() {
    if ($('.related-destinations-section ul').length > 0) {
        if ($('.related-destinations-section ul')[0].scrollWidth >  $('.related-destinations-section ul').innerWidth()) {
            $(".related-dest-show-more").show();
            $(".gray-fade-line").show();
        }
        else {
            $(".related-dest-show-more").hide();
            $(".gray-fade-line").hide();
        }
    }
}

$(window).resize(function() {
    checkForEllipses();
});

$(document).ready(function() {
    targetBlank();
});

window.renderCarousel = renderCarousel;


/***/ }),
/* 13 */
/***/ (function(module, exports) {

var filters = {

    set_summary_occupancy : function(){
        var f = jQuery('#filter-group-occupancy .filter-summary');
        var a = parseInt(jQuery('#search-adults').val());
        var c = parseInt(jQuery('#search-children').val());
        var p = parseInt(jQuery('#search-pets').val());

        // guests = adults + children
        var o = (a + c) || 1;
        o += ' ' + (o==1 ? jQuery('#dataStrings').data('guest-singular') : jQuery('#dataStrings').data('guest-plural'));

        // pets
        if(p>0)
            o += ', ' + p + ' ' + (p==1 ? jQuery('#dataStrings').data('pet-singular') : jQuery('#dataStrings').data('pet-plural')) ;

        f.text(o).attr('title',o);
    },

    set_summary_rooms : function(){
        var f = jQuery('#filter-group-rooms .filter-summary');
        var bdmn = parseInt(jQuery('#minbeds').val()) || 0;
        var bdmx = parseInt(jQuery('#maxbeds').val());
        var btmn = parseInt(jQuery('#minbaths').val()) || 0;
        var btmx = parseInt(jQuery('#maxbaths').val());
        var o = jQuery('#dataStrings').data('any');

        // beds
        if(bdmx==bdmn && bdmn>0)
              o = bdmn + ' ' + (bdmn==1 ? jQuery('#dataStrings').data('bed-singular') : jQuery('#dataStrings').data('bed-plural'));
        else if(bdmx>0)
            o = bdmn + '-' + bdmx + ' ' + (bdmx==1 ? jQuery('#dataStrings').data('bed-singular') : jQuery('#dataStrings').data('bed-plural'));
        else if(bdmn>0)
            o = bdmn + ' ' + (bdmn==1 ? jQuery('#dataStrings').data('bed-singular') : jQuery('#dataStrings').data('bed-plural'));

        // baths
        if(btmx==btmn && btmn>0)
            o += ', ' + btmn + ' ' + (btmn==1 ? jQuery('#dataStrings').data('bath-singular') : jQuery('#dataStrings').data('bath-plural'));
        else if(btmx>0)
            o += ', ' + btmn + '-' + btmx + ' ' + (btmx==1 ? jQuery('#dataStrings').data('bath-singular') : jQuery('#dataStrings').data('bath-plural'));
        else if(btmn>0)
            o += ', ' + btmn + ' ' + (btmn==1 ? jQuery('#dataStrings').data('bath-singular') : jQuery('#dataStrings').data('bath-plural'));

        f.text(o).attr('title',o);
    },

    set_summary_dates : function(){
        var f = jQuery('#filter-group-dates .filter-summary');
        var d_exact = jQuery('#search-arrival, #search-departure').val() !== '';
        var d_range = jQuery(self.wz_element + ' select[name=nights], #flexStart, #flexEnd').val() !== '';
        var o = jQuery('#dataStrings').data('any');
        if(d_exact){
            var a = new Date(jQuery('#search-arrival').val());
            var d = new Date(jQuery('#search-departure').val());
            var s = (a.getMonth() + 1) + '/' + a.getDate();
            var e = (d.getMonth() + 1) + '/' + d.getDate();
            o = s + ' - ' + e;
        } else if(d_range) {
            var a = new Date(jQuery('#flexStart').val());
            var d = new Date(jQuery('#flexEnd').val());
            var s = (a.getMonth() + 1) + '/' + a.getDate();
            var e = (d.getMonth() + 1) + '/' + d.getDate();
            var n = jQuery('#flexNights').val();
            n = n + ' night' + (n==1?'':'s');
            //n = n + ' ' + (n==1 ? )
            o = n + ' in ' + s + ' - ' + e;
        }
        f.text(o).attr('title',o);
    },

    set_summary_price : function(){
        var f = jQuery('#filter-group-price .filter-summary');
        var mn = parseInt(jQuery('#minrate').val()) || 0;
        var mx = parseInt(jQuery('#maxrate').val());
        var o = jQuery('#dataStrings').data('any');
        if(mx==mn && mx>0)
            o = mx;
        else if(mx>0)
            o = mn+' - '+mx;
        else if(mn>0)
            o = mn+' +';
        f.text(o).attr('title',o);
    },

    set_summary_amenities : function(){
        var f = jQuery('#filter-group-amenities .filter-summary');
        var a = jQuery("#amenities input:checked");
        var o = jQuery('#dataStrings').data('any');
        if(a.length){
            o = '('+a.length+') ';
            a.each(function(i, e) {
                o += (i === 0 ? '' : ', ') + jQuery.trim(jQuery(this).parent().text());
            });
        }
        f.text(o).attr('title',o);
    },

    set_date_option : function(){
        var t = jQuery('input[name=datetype]:checked').val();
        if(!t) t = 'exact';
        if(t=='flex'){
            jQuery('#search-arrival, #search-departure').val('');
        } else {
            jQuery('#flexStart, #flexEnd, #flexNights').val('');
        }
        jQuery("#datetype-exact, #datetype-flex").hide();
        jQuery("#datetype-" + t).show();
    },

    filter_group_open : function(id){
        jQuery('#'+id+' input, #'+id+' select').each(function(index, element) {
            if(jQuery(this).is(':checkbox, :radio'))
                jQuery(this).data('oldVal',jQuery(this).attr('checked')?true:false);
            else
                jQuery(this).data('oldVal',jQuery(this).val());
        });
        jQuery('#'+id).addClass('open');
    },

    filter_group_cancel : function(id){
        jQuery('#'+id+' input, #'+id+' select').each(function(index, element) {
            if(jQuery(this).is(':checkbox, :radio'))
                jQuery(this).attr('checked',jQuery(this).data('oldVal')?true:false).removeData('oldVal');
            else
                jQuery(this).val(jQuery(this).data('oldVal')).removeData('oldVal');
        });
        jQuery('#'+id).removeClass('open changed');
    },

    filter_group_clear : function(id){
        jQuery('#'+id+' input, #'+id+' select').each(function(index, element) {
            var d = jQuery(this).data().hasOwnProperty("default");
            if(jQuery(this).is(':checkbox, :radio')){
                if(d)
                    jQuery(this).prop('checked',true).change();
                else
                    jQuery(this).prop('checked',false).change();
            } else {
                if(d)
                    jQuery(this).val(jQuery(this).data('default')).change();
                else
                    jQuery(this).val('').change();
            }
            $(".info-box").hide();
        });
        this.filter_group_update(id);
    },

    filter_group_update : function(id){
        jQuery('#'+id+' input, #'+id+' select').each(function(index, element) {
            jQuery(this).removeData('oldVal');
        });

        jQuery('#'+id).removeClass('open changed');

        //Reset the page number to 1 any time we update or clear search filters but NOT when display type changes
        jQuery("[name=pageNumber]").val(1);

        search_form.update();

        removePlaceholders();
        if(id == 'filter-group-occupancy' || id == 'filter-group-amenities') {
            this.set_summary_occupancy();
            this.set_summary_amenities();
        }
        else if(id == 'filter-group-rooms') {
            this.set_summary_rooms();
        }
        else if(id == 'filter-group-dates') {
            this.set_summary_dates();
        }
        else if(id == 'filter-group-price') {
            this.set_summary_price();
        }
        $(".info-box").hide();     
        addPlaceholders();
    },

    update_filters : function(){
        removePlaceholders();
        this.set_summary_occupancy();
        this.set_summary_rooms();
        this.set_summary_dates();
        this.set_summary_price();
        this.set_summary_amenities();
        this.set_date_option();
        jQuery("#filters-list li:not(.open).changed").removeClass('changed');
        addPlaceholders();
    },

    init : function(){
        var self = this;

        // set summaries and options
        self.update_filters();

        // open filter groups
        jQuery("#filters-list").on("click", "li:not(.open) .filters-head", function(e) {
            jQuery("#filters-list li.changed").each(function(index, element) {
                self.filter_group_update(jQuery(this).attr('id'));
            });
            jQuery("#filters-list li.open").removeClass('open');

            var id = jQuery(this).parent("li").attr('id');
            self.filter_group_open(id);
        });
        // cancel and close filter groups
        jQuery(".filters-cancel").click(function(e) {
            var id = jQuery(this).parents(".filter-group").attr('id');
            self.filter_group_cancel(id);
        });
        jQuery("#filters-list").on("click", "li.open .filters-head", function(e) {
            var id = jQuery(this).parent(".filter-group").attr('id');
            self.filter_group_cancel(id);
        });
        // clear filter group and update
        jQuery(".filters-clear").click(function(e) {
            var id = jQuery(this).parents(".filter-group").attr('id');
            self.filter_group_clear(id);
        });
        // update filters
        jQuery(".filters-update").click(function(e) {
            var id = jQuery(this).parents(".filter-group").attr('id');
            self.filter_group_update(id);
        });
        // switch date option
        jQuery("input[name=datetype]").change(function(e) {
            self.set_date_option();
        });
        jQuery("#filters-list input:not([name=datetype]), #filters-list select").change(function(e) {
            jQuery(this).parents(".filter-group").addClass("changed");
        });
        // set up counters
        jQuery(".filter-counter").each(function(index, element) {
            jQuery(this).find('.counter-btn-minus').click(function(e) {
                var v = jQuery(this).siblings('.counter-val');
                var val = parseInt(v.val()) || 0;
                if(v.data().hasOwnProperty("min") && val<=v.data('min')){}
                else if(val>0) v.val(val-1).change();
            });
            jQuery(this).find('.counter-btn-plus').click(function(e) {
                var v = jQuery(this).siblings('.counter-val');
                var val = parseInt(v.val()) || 0;
                if(v.data().hasOwnProperty("max") && val>=v.data('max')){}
                else v.val(val + 1).change();
            });
        });
        // discount toggle
        jQuery("#filter_discount").change(function(e) {
            var id = jQuery(this).parents(".filter-group").attr('id');
            self.filter_group_update(id);
        });

        // validate numerical fields. leave numbers and "-" (for negative numbers)
        jQuery(".filter-range-min, .filter-range-max, .counter-val").change(function(e) {
            var o = jQuery(this).val();
            if(o.match(/[^0-9\\-]+/g)){
                o = o.replace(/[^0-9\\-]+/g, '');
            }
            if(o === ''){
                if(jQuery(this).data().hasOwnProperty('default'))
                    o = jQuery(this).data('default');
            } else {
                o = parseInt(o);
            }
            jQuery(this).val(o);
        });
        // validate min/max constraints
        jQuery("input[data-min], input[data-max]").change(function(e) {
            if(jQuery.trim(jQuery(this).val()) !== ''){
                if(jQuery(this).val() < jQuery(this).data("min"))
                    jQuery(this).val(jQuery(this).data("min"));
                else if(jQuery(this).val() > jQuery(this).data("max"))
                    jQuery(this).val(jQuery(this).data("max"));
            }
        });
        // validate min is less than max
        jQuery(".filter-range-min, .filter-range-max").change(function(e) {
            if(jQuery(this).hasClass('filter-range-min')){
                var mn = parseInt(jQuery(this).val());
                var mx = parseInt(jQuery(this).siblings('.filter-range-max').val()) || 0;
            } else {
                var mn = parseInt(jQuery(this).siblings('.filter-range-min').val()) || 0;
                var mx = parseInt(jQuery(this).val());
            }
            if(mx > 0 && mn > mx){
                jQuery(this).siblings('.filter-range-min, .filter-range-max').val('');
            }
        });
        // link dog occupancy with dog friendly amenity
        jQuery("#search-pets").change(function(e){
            jQuery("#amenityPets").prop("checked", this.value > 0);
        });
        jQuery("#amenityPets").change(function(e){
            if(!jQuery(this).prop("checked")) {
                jQuery("#search-pets").val(0);
            } else if(jQuery("#search-pets").val() === 0) {
                jQuery("#search-pets").val(1);
            }
        });
        // auto update on search suggestion click
        jQuery("#rentals-container").on("click", ".suggestion-listing a", function(){
            search_form.update();
            self.update_filters();
        });
        // submit on enter pressed
        jQuery('#filters-list input').keypress(function(e) {
            // Enter pressed?
            if(e.which == 10 || e.which == 13) {
                jQuery(this).blur();
                var id = jQuery(this).parents(".filter-group").attr('id');
                self.filter_group_update(id);
                //search_form.update();
            }
        });
        jQuery("#search-location").change(function(e) {
            search_form.update('search');
        });
    }

};

jQuery(document).ready(function() {
    filters.init();
});



/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3);
__webpack_require__(5);
__webpack_require__(4);
__webpack_require__(10);
__webpack_require__(11);
__webpack_require__(8);
__webpack_require__(9);
__webpack_require__(7);
__webpack_require__(6);
__webpack_require__(12);
module.exports = __webpack_require__(13);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/searchResults/searchResults.min.js